module.exports = __webpack_public_path__ + "src/img/index_menu/blue/5.png?b63692d029c45a2ddddeee267b8160c0";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/blue/5.png
// module id = 187
// module chunks = 0